export const ACTIVE_CAMERA_LIMIT = 6;

export function addCameraSelection(selectedIds: string[], socketId: string, limit = ACTIVE_CAMERA_LIMIT) {
  if (selectedIds.includes(socketId) || selectedIds.length >= limit) return selectedIds;
  return [...selectedIds, socketId];
}

export function toggleActiveRecipient(selectedIds: string[], socketId: string) {
  return selectedIds.includes(socketId) ? selectedIds.filter((id) => id !== socketId) : [...selectedIds, socketId];
}

export function buildActiveCameraRequest(socketId: string, clientId?: string) {
  return { socketId, clientId, withAudio: true };
}

export function addConfirmedCameraSelection(selectedIds: string[], socketId: string) {
  return addCameraSelection(selectedIds, socketId);
}

export function applyActiveCameraSignal(selectedIds: string[], socketId: string, status: "received" | "streaming" | "frame") {
  return status === "streaming" || status === "frame" ? addConfirmedCameraSelection(selectedIds, socketId) : selectedIds;
}

export function getMessageDeliveryTone() {
  return { frequency: 720, duration: 0.18, repetitions: 2 };
}

export function getMessageDeliveryFeedback(received: boolean) {
  return received ? getMessageDeliveryTone() : null;
}

export function buildActiveBroadcast(recipients: Array<{ socketId: string; clientId?: string; eventId: number | null }>, message: string) {
  return recipients.map((recipient) => ({ socketId: recipient.socketId, clientId: recipient.clientId, eventId: recipient.eventId, message }));
}

export function getEventBoundValue<T>(values: Record<number, T>, eventId: number | null | undefined) {
  return eventId ? values[eventId] || null : null;
}

export function describeProtectedTripAlert(data: { type: string; reportedBy: string; destinationLabel: string }) {
  if (data.type === "not_started") return `TRAJETO NÃO INICIADO: ${data.reportedBy} ainda não saiu do ponto de origem para ${data.destinationLabel}`;
  if (data.type === "deviation") return `DESVIO DE ROTA: ${data.reportedBy} saiu do trajeto para ${data.destinationLabel}`;
  if (data.type === "delayed") return `ATRASO DE TRAJETO: ${data.reportedBy} ultrapassou a previsão para ${data.destinationLabel}`;
  if (data.type === "fast_walking") return `VELOCIDADE INCOMPATÍVEL: ${data.reportedBy} está mais rápida que o previsto a pé para ${data.destinationLabel}`;
  return `PARADA PROLONGADA: ${data.reportedBy} está sem se movimentar no trajeto para ${data.destinationLabel}`;
}

export function registerUniqueProtectedTripAlert(seenKeys: Set<string>, data: { tripId: number; type: string; timestamp: number }) {
  const key = `${data.tripId}:${data.type}:${data.timestamp}`;
  if (seenKeys.has(key)) return false;
  seenKeys.add(key);
  if (seenKeys.size > 100) seenKeys.clear();
  return true;
}
